import type { TTile } from '@core/tile';
import type { TSeat } from '@core/types';

export interface IGameSceneLifecycleState {
  discardAnnounceEnabled: boolean;
  lastDrawnPerSeat: Array<TTile | null>;
  pendingDrawnPerSeat: Array<TTile | null>;
  lastDiscarded: { tile: TTile; fromSeat: TSeat } | null;
  discardSequence: TTile[];
  playerActionPending: boolean;
  roundTraceSequence: number;
  roundEnded: boolean;
  activeTurnSeat: TSeat | null;
  turnHandSuppressedUntilDiscardSeat: TSeat | null;
  tenpaiOfferActive: boolean;
  gatedAISeats: TSeat[];
  animatingTenpaiPeek: boolean;
  previewTenpaiSeats: Set<TSeat>;
  peekLoopActive: boolean;
  stepMode: boolean;
  previewHandSeat: TSeat;
  animatingPlayerDiscard: boolean;
  animatingPlayerDraw: boolean;
  animatingFlower: boolean;
  gamePaused: boolean;
}

/** Phaser 會重用同一個 Scene instance；每次 create 都必須取得全新的單局暫態。 */
export function createGameSceneLifecycleState(): IGameSceneLifecycleState {
  return {
    discardAnnounceEnabled: true,
    lastDrawnPerSeat: [null, null, null, null],
    pendingDrawnPerSeat: [null, null, null, null],
    lastDiscarded: null,
    discardSequence: [],
    playerActionPending: false,
    roundTraceSequence: 0,
    roundEnded: false,
    activeTurnSeat: null,
    turnHandSuppressedUntilDiscardSeat: null,
    tenpaiOfferActive: false,
    gatedAISeats: [],
    animatingTenpaiPeek: false,
    previewTenpaiSeats: new Set<TSeat>(),
    peekLoopActive: false,
    stepMode: false,
    previewHandSeat: 0,
    animatingPlayerDiscard: false,
    animatingPlayerDraw: false,
    animatingFlower: false,
    gamePaused: false,
  };
}
